import { AppBar, Box, IconButton, Toolbar, Typography } from '@mui/material';
import { Menu as MenuIcon, Logout as LogoutIcon } from '@mui/icons-material';
import { useAuth } from '../../features/auth/hooks/useAuth.tsx';
import { useNavigate } from 'react-router-dom';

interface HeaderProps {
    toggleSidebar: () => void;
    isSmallScreen: boolean;
}

const Header = ({ toggleSidebar, isSmallScreen }: HeaderProps) => {
    const { logout } = useAuth();
    const navigate = useNavigate();

    return (
        <AppBar
            position="fixed"
            sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
        >
            <Toolbar sx={{ justifyContent: 'space-between' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    {isSmallScreen && (
                        <IconButton
                            color="inherit"
                            onClick={toggleSidebar}
                            aria-label="Öppna meny"
                            edge="start"
                        >
                            <MenuIcon />
                        </IconButton>
                    )}
                    <Typography
                        fontWeight={700}
                        variant="h5"
                        component="div"
                        sx={{
                            color: 'primary.contrastText',
                            letterSpacing: '-0.5px',
                            cursor: 'pointer',
                        }}
                        onClick={() => navigate('/')}
                    >
                        LogMed{' '}
                        <Box
                            component="span"
                            sx={{
                                fontWeight: 400,
                                color: 'rgba(255,255,255,0.7)',
                            }}
                        >
                            Förbrukningsjournal
                        </Box>
                    </Typography>
                </Box>
                <IconButton
                    color="inherit"
                    onClick={logout}
                    size="small"
                    aria-label="Logga ut"
                >
                    <LogoutIcon fontSize="small" />
                </IconButton>
            </Toolbar>
        </AppBar>
    );
};

export default Header;
